import { Loader2 } from "lucide-react";

export default function FullScreenLoader({ text = "Loading...", show = true }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-white/80 backdrop-blur-sm flex items-center justify-center">
      <div className="flex flex-col items-center">
        {/* Animated Rings */}
        <div className="relative flex items-center justify-center w-24 h-24">
          <div className="absolute w-24 h-24 border-4 border-indigo-100 rounded-full"></div>

          <div className="absolute w-24 h-24 border-4 border-transparent border-t-indigo-600 rounded-full animate-spin"></div>

          <div className="absolute w-16 h-16 border-4 border-transparent border-t-purple-500 rounded-full animate-spin [animation-direction:reverse] [animation-duration:1.5s]"></div>

          <div className="bg-indigo-600 p-3 rounded-full shadow-lg">
            <Loader2 className="w-6 h-6 text-white animate-spin" />
          </div>
        </div>

        {/* Loading Text */}
        <p className="mt-6 text-gray-700 font-medium tracking-wide animate-pulse">
          {text}
        </p>

        {/* Dots */}
        <div className="flex gap-1 mt-2">
          <span className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce"></span>
          <span
            className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce"
            style={{ animationDelay: "0.15s" }}
          ></span>
          <span
            className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce"
            style={{ animationDelay: "0.3s" }}
          ></span>
        </div>
      </div>
    </div>
  );
}
